import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GuardFieldOperationsView } from '../guard-field-operations.service';
import { GuardTake } from '../guard-takes.service';
import { IrrigatorParcel } from '../irrigator-parcels.service';
import { SidebarMenuComponent } from '../sidebar-menu/sidebar-menu.component';
import { ProfileKey } from '../visor.types';

@Component({
  selector: 'app-mobile-menu',
  imports: [SidebarMenuComponent],
  templateUrl: './mobile-menu.component.html',
  styleUrl: './mobile-menu.component.scss'
})
export class MobileMenuComponent {
  @Input({ required: true }) profile: ProfileKey = 'public';
  @Input() irrigatorParcelsPanelVisible = true;
  @Input() irrigatorParcels: IrrigatorParcel[] = [];
  @Input() irrigatorParcelsLoading = false;
  @Input() irrigatorParcelsError = '';
  @Input() selectedIrrigatorParcelId = '';
  @Input() guardTakesPanelVisible = true;
  @Input() guardTakes: GuardTake[] = [];
  @Input() guardTakesLoading = false;
  @Input() guardTakesError = '';
  @Input() selectedGuardTakeId = '';
  @Input() guardFieldOperationsView: GuardFieldOperationsView = null;
  @Input() incidentsSummaryVisible = false;
  @Input() maintenanceSummaryVisible = false;
  @Input() publicInfoVisible = false;
  @Input() aboutRamVisible = false;

  @Output() closed = new EventEmitter<void>();
  @Output() logoutRequested = new EventEmitter<Event>();
  @Output() informationToggled = new EventEmitter<void>();
  @Output() aboutRequested = new EventEmitter<void>();
  @Output() irrigatorParcelsPanelToggled = new EventEmitter<void>();
  @Output() irrigatorParcelSelected = new EventEmitter<IrrigatorParcel>();
  @Output() guardTakesPanelToggled = new EventEmitter<void>();
  @Output() guardTakeSelected = new EventEmitter<GuardTake>();
  @Output() guardFieldOperationsRequested = new EventEmitter<GuardFieldOperationsView>();

  protected toggleInformation(): void {
    this.informationToggled.emit();
    this.closed.emit();
  }

  protected showAbout(): void {
    this.aboutRequested.emit();
    this.closed.emit();
  }

  protected toggleIrrigatorParcelsPanel(): void {
    this.irrigatorParcelsPanelToggled.emit();
  }

  protected selectIrrigatorParcel(parcel: IrrigatorParcel): void {
    this.irrigatorParcelSelected.emit(parcel);
    this.closed.emit();
  }

  protected toggleGuardTakesPanel(): void {
    this.guardTakesPanelToggled.emit();
  }

  protected selectGuardTake(take: GuardTake): void {
    this.guardTakeSelected.emit(take);
    this.closed.emit();
  }

  protected showGuardFieldOperations(view: GuardFieldOperationsView): void {
    this.guardFieldOperationsRequested.emit(view);
    this.closed.emit();
  }

  protected logout(event: Event): void {
    this.logoutRequested.emit(event);
    this.closed.emit();
  }
}
